var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { E as EntityType, C as ComponentCategory, W as WeaponTypeEnum, a as EnemyTypeEnum } from "../../enums-86f58524.js";
import { type, defaultValue, Bitecs, Component, BitecsSchema, Schema } from "../../decorators/type.js";
import { registerSchema } from "../ComponentRegistry.js";
import "../types.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let EntityTypeSchema = class extends BitecsSchema {
  constructor() {
    super(...arguments);
    __publicField(this, "_entityType");
  }
  static get entityType() {
    return EntityTypeSchema.store.entityType[this.id];
  }
  static set entityType(value) {
    EntityTypeSchema.store.entityType[this.id] = value;
    EntityTypeSchema.store.__changes[this.id] |= 1;
  }
};
__decorateClass([
  type(EntityType),
  defaultValue(EntityType.ENTITY)
], EntityTypeSchema.prototype, "_entityType", 2);
EntityTypeSchema = __decorateClass([
  Bitecs(),
  Component("EntityType")
], EntityTypeSchema);
registerSchema(ComponentCategory.TYPE, EntityTypeSchema);
let WeaponTypeSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "weaponType");
  }
};
__decorateClass([
  type(WeaponTypeEnum),
  defaultValue(WeaponTypeEnum.NONE)
], WeaponTypeSchema.prototype, "weaponType", 2);
WeaponTypeSchema = __decorateClass([
  Component("WeaponType")
], WeaponTypeSchema);
registerSchema(ComponentCategory.TYPE, WeaponTypeSchema);
let EnemyTypeSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "enemyType");
  }
};
__decorateClass([
  type("number"),
  defaultValue(EnemyTypeEnum.U_DEF)
], EnemyTypeSchema.prototype, "enemyType", 2);
EnemyTypeSchema = __decorateClass([
  Component("EnemyType")
], EnemyTypeSchema);
registerSchema(ComponentCategory.TYPE, EnemyTypeSchema);
let PlayerTypeSchema = class extends Schema {
};
PlayerTypeSchema = __decorateClass([
  Component("PlayerType")
], PlayerTypeSchema);
registerSchema(ComponentCategory.TYPE, PlayerTypeSchema);
let AllyTypeSchema = class extends Schema {
};
AllyTypeSchema = __decorateClass([
  Component("AllyType")
], AllyTypeSchema);
registerSchema(ComponentCategory.TYPE, AllyTypeSchema);
let PickupTypeSchema = class extends Schema {
};
PickupTypeSchema = __decorateClass([
  Component("PickupType")
], PickupTypeSchema);
registerSchema(ComponentCategory.TYPE, PickupTypeSchema);
let ProjectileTypeSchema = class extends Schema {
};
ProjectileTypeSchema = __decorateClass([
  Component("ProjectileType")
], ProjectileTypeSchema);
registerSchema(ComponentCategory.TYPE, ProjectileTypeSchema);
let WallTypeSchema = class extends Schema {
};
WallTypeSchema = __decorateClass([
  Component("WallType")
], WallTypeSchema);
registerSchema(ComponentCategory.TYPE, WallTypeSchema);
let AltarTypeSchema = class extends Schema {
};
AltarTypeSchema = __decorateClass([
  Component("AltarType")
], AltarTypeSchema);
registerSchema(ComponentCategory.TYPE, AltarTypeSchema);
let InteractableTypeSchema = class extends Schema {
};
InteractableTypeSchema = __decorateClass([
  Component("InteractableType")
], InteractableTypeSchema);
registerSchema(ComponentCategory.TYPE, InteractableTypeSchema);
let DoorTypeSchema = class extends Schema {
};
DoorTypeSchema = __decorateClass([
  Component("DoorType")
], DoorTypeSchema);
registerSchema(ComponentCategory.TYPE, DoorTypeSchema);
let AuraTypeSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "spawnTime");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], AuraTypeSchema.prototype, "spawnTime", 2);
AuraTypeSchema = __decorateClass([
  Component("AuraType")
], AuraTypeSchema);
registerSchema(ComponentCategory.TYPE, AuraTypeSchema);
let MapEntityTypeSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "width");
    __publicField(this, "height");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], MapEntityTypeSchema.prototype, "width", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], MapEntityTypeSchema.prototype, "height", 2);
MapEntityTypeSchema = __decorateClass([
  Component("MapEntityType")
], MapEntityTypeSchema);
registerSchema(ComponentCategory.TYPE, MapEntityTypeSchema);
export {
  AllyTypeSchema,
  AltarTypeSchema,
  AuraTypeSchema,
  DoorTypeSchema,
  EnemyTypeSchema,
  EntityTypeSchema,
  InteractableTypeSchema,
  MapEntityTypeSchema,
  PickupTypeSchema,
  PlayerTypeSchema,
  ProjectileTypeSchema,
  WallTypeSchema,
  WeaponTypeSchema
};
//# sourceMappingURL=Types.js.map
